import axios from 'axios';
import { objectToQuery } from '@mx/util/object-to-query';
import { toast, modal } from '@mx/vix';
import { bridge } from './bridge';
import { env } from './env';
import { monitor } from './monitor';

export enum ErrorLevel {
  TOAST = 1,
  MODAL_EXIT,
  MODAL,
  EXIT,
  INLINE
}

interface AjaxSettings {
  showToast?: boolean;
  needErrorHandler?: boolean;
  formatError?: boolean;
}

class CustomError extends Error {
  constructor(message: string, public level: ErrorLevel, public code: number) {
    super(message);
  }
}

export function post(
  url: string,
  data: any,
  settings: AjaxSettings = { showToast: true, needErrorHandler: true, formatError: true}
) {
  if (settings.showToast) {
    toast.show();
  }
  return axios
    .post(url, data, {
      transformRequest: (rawData) => {
        rawData = { ...env.commonParams, ...rawData };
        return objectToQuery(rawData);
      }
    })
    .then((res) => {
      if (settings.showToast) {
        toast.hide();
      }
      const body = res.data; // 响应体
      if ('error' in body) {
        if (!settings.formatError) {
          throw res.data;
        }
        const error = body.error;
        throw new CustomError(error.message, error.level, error.code);
      }
      return body.data; // 响应体中数据
    })
    .catch((error) => {
      if (settings.showToast) {
        toast.hide();
      }
      if (settings.needErrorHandler) {
        errorHandler(error);
      }
      monitor.captureAjaxErrorMessage(url, {
        tag: {
          ...data
        }
      });
      throw error;
    });
}

function errorHandler(error: CustomError): void {
  // 通用错误码处理
  switch (error.code) {
  }

  switch (error.level) {
    case ErrorLevel.TOAST:
      toast.show('text', error.message);
      break;
    case ErrorLevel.MODAL_EXIT:
    case ErrorLevel.EXIT:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
            bridge.closeWebView();
          }
        }
      });
      break;
    case ErrorLevel.MODAL:
      modal.show({
        title: '提示',
        content: error.message,
        button: {
          text: '知道了',
          onClick: () => {
            modal.hide();
          }
        }
      });
      break;
  }
}
